import {
  type GuidedV2StrategyData,
  type GuidedV2StrategyParams,
  GuidedV2StrategyService
} from '../../GuidedV2StrategyService';
import {GuidedV2FallbackQuickRenderLink} from '../../../guided2/subcomponents/quick-link/quick-link';
import {h} from '@stencil/core';

import type {GuidedV2ResultQuickLinkUiProvider} from '../../../guided2/models/ui';
import {
  GuidedGenericQuickLink,
  type GuidedV2Link,
  type GuidedV2LinkAttribute,
  type GuidedV2LinkTag
} from '../../../guided2/models/quick-link';
import type {GuidedV2Emitters} from '../../../guided2/models/eventNames';
import type {labelProviderInterface} from '../../../LabelProviderInterface';





/**
 * Default quick link template mapper
 * @param quickLink
 */
const defaultQuickLinkTemplateMapper
  = ({
    eventEmitters,
    labelProvider
  }:{eventEmitters: GuidedV2Emitters, labelProvider:labelProviderInterface})=> <T extends GuidedV2Link<unknown>> (quickLink:T) =>{
      //If link element provides its own rendering method, we use it
      if (quickLink.template instanceof Function) {
        const params = Object.assign({eventEmitters, labelProvider}, quickLink.details);
        return quickLink.template(params);
      }

      //else we check if rendered template is provided, then we render the link
      switch (quickLink.template) {
      //When we define different templates for result card, the code goes here
      //But if it belongs to whole different strategy, new strategy must be defined
      //Simple new template = here.
      // Whole set of templates = new strategy
      default:
      case 'default':
        const l = quickLink as GuidedV2Link<GuidedGenericQuickLink>;
        const url = l?.details?.quickLinkOpenUrl ?? '';
        const title = l?.details.quickLinkMarkup || l?.details?.quickLinkTitle;
        const description = (l?.details.quickLinkDescriptionMarkup || l?.details?.quickLinkDescription) ?? undefined;
        const category = l?.details.quickLinkCategory ?? '';

        const tags: Array<GuidedV2LinkTag> = l.details?.quickLinkBadges?.tags ?? [];
        const attributes: Array<GuidedV2LinkAttribute> = l.details?.quickLinkBadges?.attributes ?? [];
        return <GuidedV2FallbackQuickRenderLink
          eventEmitters={eventEmitters}
          title={title}
          description={description}
          url={url}
          category={category}
          tags={{tags, attributes}}/>;
      }
  };



export class GuidedV2DefaultService extends GuidedV2StrategyService {

  constructor(details: GuidedV2StrategyParams) {
      super();
      this._details = details;
  }

  getSchema() {
      return this._details.schema;
  }

  getQuickLinkTemplateMapper({
    eventEmitters,
    labelProvider
  }:{eventEmitters: GuidedV2Emitters, labelProvider:labelProviderInterface}): GuidedV2ResultQuickLinkUiProvider {
      // Here we switch between different implementations of strategies
      // When competing strategies are implemented, we can change the implementation


      switch (this._details.quickLinkTemplateMapperType) {

      default:
      case 'default':
        return defaultQuickLinkTemplateMapper({
          eventEmitters,
          labelProvider
        });
      }
  }
}
